import { PRIORITY_LABELS, type Priority } from '@kanban/shared';

/** Prioritaet farbcodiert (SPEC 9.1). Prioritaet 0 wird nicht angezeigt. */
export function PriorityDot({ priority }: { priority: Priority }) {
  if (priority === 0) return null;
  return (
    <span
      className="inline-block h-2 w-2 shrink-0 rounded-full"
      style={{ backgroundColor: `var(--color-priority-${priority})` }}
      title={`Priorität ${PRIORITY_LABELS[priority]}`}
      aria-label={`Priorität ${PRIORITY_LABELS[priority]}`}
    />
  );
}
